import { bindContributionProvider, createContributionProvider } from "../../../common/contribution-provider";

import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultCanvasCircleRender } from "./circle-render";

import { DefaultBaseInteractiveRenderContribution } from "./contributions";

import { CircleRenderContribution } from "./contributions/constants";

import { CircleRender, GraphicRender } from "./symbol";

const loadedCircleModuleContexts = new WeakSet;

export function bindCircleRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedCircleModuleContexts, bind) || (bind(DefaultCanvasCircleRender).toDynamicValue((({container: container}) => new DefaultCanvasCircleRender(createContributionProvider(CircleRenderContribution, container)))).inSingletonScope(), 
    bind(CircleRender).toService(DefaultCanvasCircleRender), bind(GraphicRender).toService(CircleRender), 
    bind(CircleRenderContribution).toService(DefaultBaseInteractiveRenderContribution), 
    bindContributionProvider(bind, CircleRenderContribution));
}

export const circleModule = bindCircleRenderModule;
//# sourceMappingURL=circle-module.js.map
